import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("AGREEMENTS");
const CRUD_ACTION_HANDLERS = getActionHandler("AGREEMENTS");

export default function agreements(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
